import { DomHelpers } from '../core/DomHelpers.js';

/**
 * Делегирование кликов по .design-item__title-wrapper.
 * @param root Корневой контейнер, внутри которого находится список элементов.
 */
function initDesignItemToggle(root) {
    const onClick = (ev) => {
        const target = ev.target;
        if (!target)
            return;
        // Ищем заголовок
        const title = target.closest('.design-item__title-wrapper');
        if (!title || !root.contains(title))
            return;
        // Находим родителя-айтем
        const wrapper = title.closest('.design-item__inner-wrapper');
        if (!wrapper)
            return;
        // Коллекция
        const collection = wrapper.querySelector('.design-inner-collection');
        if (collection) {
            DomHelpers.slideToggle(collection, 300);
        }
        // Кнопка-стрелка
        const btn = wrapper.querySelector('.btn-icon-moveup');
        if (btn) {
            btn.classList.toggle('active');
        }
    };
    root.addEventListener('click', onClick);
}

export { initDesignItemToggle };
